/**
 * Sound options available during sessions.
 * Each entry maps a 1-based sound_option (stored in DB) to its file path and label.
 * When adding/changing sounds, update this list — it's the single source of truth
 * consumed by the Sidebar selector and session completion payloads.
 */
export const SOUND_OPTIONS = [
  { file: "/sounds/Synth_Tick_C_lo.wav", label: "Click 1" },
  { file: "/sounds/Synth_Block_E_hi.wav", label: "Click 2" },
  { file: "/sounds/Perc_Clackhead_lo.wav", label: "Click 3" },
];

/** Default sound file path. */
export const DEFAULT_SOUND_FILE = SOUND_OPTIONS[0].file;

/**
 * Convert a sound file path to a 1-based DB sound_option number.
 * Returns 1 (default) if the file isn't found.
 */
export function soundFileToOption(soundFile) {
  const index = SOUND_OPTIONS.findIndex((s) => s.file === soundFile);
  return index >= 0 ? index + 1 : 1;
}
